import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { LanguageService } from 'src/app/services/languageservice/language.service';

@Component({
  selector: 'app-language-switch',
  templateUrl: './language-switch.component.html',
  styleUrls: ['./language-switch.component.scss'],
})
export class LanguageSwitchComponent implements OnInit {


  languages: any[] = []
  constructor(public languageService: LanguageService,
    private platform: Platform
    ) { 

  }

  ngOnInit() {
    this.languages = this.languageService.getLanguage()
  }

  compare(e1: any, e2: any): boolean {
    return e1 && e2 ? e1.value == e2.value : e1 == e2;
  }

  changeLanguage(event) {
    this.languageService.selectLanguage(event.target.value)
    localStorage.setItem("selectedlanguage",JSON.stringify( event.target.value))
    
  }
}
